export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }
            if (value.length != 11 || value.substring(0, 1) != '1') {
                return callback(new Error('手机号格式不正确'));
            }
            callback();
        };
        return {
            validatePhone: validatePhone,
            form: {}
        }
    },
    mounted: function() {
        var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        this.form = {
            avatar: userInfo.avatar == "" ? "" : (this.$global.baseUrl + userInfo.avatar),
            fileList: [],
            name: userInfo.name,
            loginName: userInfo.loginName,
            idNumber: userInfo.idNumber,
            userType: userInfo.userType == 1 ? '管理员' : '承包商人员',
            orgFullPath: userInfo.fullOrgName,
            position: userInfo.postName,
            gender: userInfo.gender == 0 ? null : userInfo.gender,
            phone: userInfo.phone,
            createDate: userInfo.createDate
        }
    },
    methods: {
        /**
         * 点击事件
         * @param {*} from 
         */
        clickEvent: function(from) {
            var _this = this;
            switch (from) {
                case "saveInfo":
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            _this.requestUpdateInfo();
                        } else {
                            return false;
                        }
                    });
                    break;
            }
        },

        /**
         * 上传失败
         * @param {*} files 
         * @param {*} fileList 
         */
        handleError: function(err, file, fileList) {
            this.$message.closeAll();
            this.$message.error("上传失败");
        },

        /**
         * 上传成功
         * @param {*} response 
         * @param {*} file 
         * @param {*} fileList 
         */
        handleSuccess: function(response, file, fileList) {
            this.form.fileList = [];
            if (response.success) {
                this.form.avatar = this.$global.baseUrl + response.data.path;
                this.requestUpdateAvatar(response.data.path);
            } else {
                this.$message.closeAll();
                this.$message.error(response.message);
            }
        },

        /**
         * 修改头像
         * @param {*} avatarPath 
         */
        requestUpdateAvatar: function(avatarPath) {
            this.$post({
                url: 'user/updateInfo',
                params: {
                    avatarPath: avatarPath
                }
            }, true).then(response => {
                this.$message.closeAll();
                this.$message.success("修改成功");
                var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                userInfo.avatar = avatarPath;
                sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
                this.$event.$emit("updateUserInfo");
            });
        },

        /**
         * 更新个人信息
         */
        requestUpdateInfo: function() {
            this.$post({
                url: 'user/updateInfo',
                params: {
                    name: this.form.name,
                    loginName: this.form.loginName,
                    idNumber: this.form.idNumber,
                    gender: this.form.gender,
                    phone: this.form.phone
                }
            }, true).then(response => {
                var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                userInfo.name = this.form.name;
                userInfo.loginName = this.form.loginName;
                userInfo.idNumber = this.form.idNumber;
                userInfo.gender = this.form.gender;
                userInfo.phone = this.form.phone;
                sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
                this.$message.closeAll();
                this.$message.success("修改成功");
                this.$event.$emit("updateUserInfo");
            });
        },

        /**
         * 修改密码
         */
        requestUpdatePassword: function() {
            this.$post({
                url: 'user/updatePassword',
                params: {
                    oldPassword: this.$md5(this.psdForm.oldPassword),
                    newPassword: this.$md5(this.psdForm.newPassword)
                }
            }, true).then(response => {
                this.psdForm.oldPassword = "";
                this.psdForm.newPassword = "";
                this.psdForm.confirmPassword = "";
                this.$message.closeAll();
                this.$message.success("修改成功");
            });
        }
    }
};